const resetBar = document.querySelector('.form-login__reset-bar-wrapper');

if (resetBar) {
    const handleResetBarWidth = (containerClass, resetBar) => {
        const containerWidth = containerClass.offsetWidth;
        resetBar.style.maxWidth = `${window.innerWidth < 991.98
                ? containerWidth - 32
                : containerWidth - 48
            }px`;
    };
    const containerClass = document.querySelector(
        'main > .container'
    );
    if (containerClass) {
        handleResetBarWidth(containerClass, resetBar);
        window.addEventListener('resize', () => {
            handleResetBarWidth(containerClass, resetBar);
        });
    }
}
